<template>
	<div>
		<Loading v-if="loading" />
		<Header />
		<TitlePage />
		<!-- UI DESKTOP -->
		<template v-if="!isMobile">
			<EditListingDesktop
				:key="$route.name === 'AddListing' ? 'addListing' : 'editListing'"
				@loading="loading = $event"
			/>
		</template>
		<!-- UI MOBILE -->
		<template v-else>
			<EditListingMobile @loading="loading = $event" />
		</template>
		<Footer />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import EditListingDesktop from '@/components/listing/editListing/EditListingDesktop';
import EditListingMobile from '@/components/listing/editListing/mobile/EditListingMobile';

import Loading from '@/components/ui/loading';
import Header from '@/components/ui/header';
import Footer from '@/components/ui/footer';
import TitlePage from '@/components/ui/titlePage';

export default {
	components: {
		EditListingDesktop,
		EditListingMobile,
		Header,
		Footer,
		TitlePage,
		Loading
	},
	data() {
		return {
			loading: false
		};
	},
	computed: {
		...mapGetters('UserController', ['isMobile'])
	}
};
</script>

<style lang="scss"></style>
